import { render, staticRenderFns } from "./myproduct.vue?vue&type=template&id=fb5bc43e&scoped=true"
import script from "./myproduct.vue?vue&type=script&lang=js"
export * from "./myproduct.vue?vue&type=script&lang=js"
import style0 from "./myproduct.vue?vue&type=style&index=0&id=fb5bc43e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5bc43e",
  null
  
)

export default component.exports